import PasswordRecoveryPage from '@/pages/PasswordRecoveryPage/PasswordRecoveryPage.vue'

export default PasswordRecoveryPage
